module.exports = __webpack_public_path__ + "GothamBook.ca6e213b5621a1a11a11.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/GothamBook.ttf
// module id = ../../../../../src/assets/fonts/gotham/GothamBook.ttf
// module chunks = styles